import { getStore } from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setIsSaving', function setIsSaving(newValue) {
    getStore().isSaving = newValue;
});
//# sourceMappingURL=setIsSaving.js.map